module.exports = __webpack_public_path__ + "static/img/logo.c38fab4.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/logo.png
// module id = bgxh
// module chunks = 33